import { ElementPlaceholderMap } from './ElementPlaceholdersDebugToolPopup';
import { DEBUG_ELEMENT_PLACEHOLDER_STATE_UPDATE } from './PlaceholderDebugToolConstants';

const initialState = new Map();

export default (state = initialState, action: { type: string; payload: ElementPlaceholderMap }) => {
    switch (action.type) {
        case DEBUG_ELEMENT_PLACEHOLDER_STATE_UPDATE:
            return new Map(action.payload);
        default:
            return state;
    }
};
